import React from 'react';

interface ProfileProps {
  title: string;
}

const Profile: React.FC<ProfileProps> = ({ title }) => {
  return (
    <div className='rounded-lg bg-gray-200 p-4'>
      <h1 className='text-3xl text-gray-700'>{title}</h1>
    </div>
  );
};

export default Profile;
